import { styled } from 'linaria/lib/react';
import React, { useState, useRef, useEffect } from 'react';
import { BurgerMenu } from './BurgerMenu';
import { BurgerMenuList } from './BurgerMenuList';
export const Burger = () => {
  const [isMenuVisible, setMenuVisible] = useState(false);
  const burgerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (burgerRef.current && !burgerRef.current.contains(event.target as Node)) {
        setMenuVisible(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const handleClick = () => {
    setMenuVisible(true);
  };
  return <WrapperBurger ref={burgerRef}>
      <BurgerMenu onClick={handleClick}>{isMenuVisible && <BurgerMenuList />}</BurgerMenu>
    </WrapperBurger>;
};
const WrapperBurger = /*#__PURE__*/styled("div")({
  name: "WrapperBurger",
  class: "w1g64lsa"
});

require("./Burger.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./Burger.tsx");